<div class="pendencias">
  <div class="container-fluid wrapper-content">
    <div class="ibox">
      <div class="ibox-title">
        <h2 class="title">
          Pendências
        </h2>
      </div>
      <div class="ibox-content">
        <div class="row">
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-safra" class="control-label">Safra</label>
              <select
                name="filter-safra"
                id="filter-safra"
                class="form-control"
                ng-options="safra.descricao for safra in $root.safras track by safra.id"
                ng-model="$ctrl.safra"
                ng-change="$ctrl.loadPendencias()"
              ></select>
            </div>
          </div>
          <div class="col-xs-4">
            <div class="form-group">
              <label for="filter-gleba" class="control-label">Talhão</label>
              <select
                name="filter-gleba"
                id="filter-gleba"
                class="form-control"
                ng-options="gleba.descricao for gleba in $root.currentPropriedade.glebas track by gleba.id"
                ng-model="$ctrl.gleba"
                ng-change="$ctrl.loadPendencias()"
              >
                <option value="">Todas</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
            <div class= "col-xs-2">
              <div class="box box-green-striped"></div>
              <div>Em andamento</div>
            </div>
            <div class= "col-xs-3">
              <div class="box box-yellow"></div>
              <div>Iniciar imediatamente</div>
            </div>
            <div class= "col-xs-2">
              <div class="box box-red"></div>
              <div>Atrasada</div>
            </div>
            <div class= "col-xs-3">
              <div class="box box-red-striped"></div>
              <div>Em andamento e atrasada</div>
            </div>
            <div class= "col-xs-2">
              <div class="box box-gray"></div>
              <div>Dentro do prazo</div>
            </div>
          </div>
      </div>
    </div>

    <p class="text-cinza text-center" ng-show="$ctrl.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Carregando Pendências...
    </p>
    <div class="text-cinza text-center" ng-show="!$ctrl.loading && $ctrl.pendencias.length === 0">
      <h3>
        <i class="fa fa-tasks"></i>
        Nenhuma pendência encontrada :)
      </h3>
    </div>
    <pendencias-grid
      pendencias="$ctrl.pendencias"
      on-update="$ctrl.loadPendencias()"
    ></pendencias-grid>
  </div>
</div>
